<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="detailProduct">
    <h1 class="text-center" style="margin-top: 3%">Product Master</h1>
    <div class="group-1" style="margin-bottom: 5rem">
      <div class="row ln1" style="margin-top: 5%">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product Name</div>
          <h6>{{ checkEmptyValue(objProduct.productName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product Display Name</div>
          <h6>{{ checkEmptyValue(objProduct.productDisplayName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product Code</div>
          <h6>{{ checkEmptyValue(objProduct.productCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>SAP code</div>
          <h6>{{ checkEmptyValue(objProduct.sap13DigitCode) }}</h6>
        </div>
      </div>
      <div class="row ln2">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Brand Code</div>
          <h6>{{ checkEmptyValue(objProduct.brandCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Country</div>
          <h6>{{ checkEmptyValue(objProduct.country) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Quantity (CEGID)</div>
          <h6>{{ checkEmptyValue(objProduct.productQuantity) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Created date</div>
          <h6>{{ checkEmptyValue(productCreateDate) }}</h6>
        </div>
      </div>
      <div class="row ln2-1">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Updated date</div>
          <h6>{{ checkEmptyValue(productUpdateDate) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Status</div>
          <h6>{{ objProduct.status ? "Active" : "In Active" }}</h6>
        </div>
      </div>
    </div>
    <div class="group-2" style="margin-bottom: 5rem">
      <div class="row ln3">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product category code</div>
          <h6>{{ checkEmptyValue(objProduct.productCategoryCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product category</div>
          <h6>{{ checkEmptyValue(objProduct.productCategoryName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product sub category code</div>
          <h6>{{ checkEmptyValue(objProduct.productSubCategoryCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Product sub category name</div>
          <h6>{{ checkEmptyValue(objProduct.productSubCategoryName) }}</h6>
        </div>
      </div>
      <div class="row ln4">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Type code</div>
          <h6>{{ checkEmptyValue(objProduct.productTypeCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Type name</div>
          <h6>{{ checkEmptyValue(objProduct.productTypeName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Segment code</div>
          <h6>{{ checkEmptyValue(objProduct.productSegmentCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Segment name</div>
          <h6>{{ checkEmptyValue(objProduct.productSegmentName) }}</h6>
        </div>
      </div>
      <div class="row ln5">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Line code</div>
          <h6>{{ checkEmptyValue(objProduct.productLineCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Line name</div>
          <h6>{{ checkEmptyValue(objProduct.productLineName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Material Type code</div>
          <h6>{{ checkEmptyValue(objProduct.materialType) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Material Type Description</div>
          <h6>{{ checkEmptyValue(objProduct.materialTypeDescription) }}</h6>
        </div>
      </div>
    </div>
    <div class="group-3">
      <div class="row ln6">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Local category code</div>
          <h6>{{ checkEmptyValue(objProduct.localCategoryCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Local category name</div>
          <h6>{{ checkEmptyValue(objProduct.localCategoryName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Local sub-category code</div>
          <h6>{{ checkEmptyValue(objProduct.localSubCategoryCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Local sub-category name</div>
          <h6>{{ checkEmptyValue(objProduct.localSubCategoryName) }}</h6>
        </div>
      </div>
      <div class="row ln7">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Local sub-sub category</div>
          <h6>{{ checkEmptyValue(objProduct.localSubSubCategoryName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Local sub-sub category Code</div>
          <h6>{{ checkEmptyValue(objProduct.localSubSubCategoryCode) }}</h6>
        </div>
      </div>
    </div>
    <div class="row footer">
      <div class="col text-right">
        <button
          class="btn btn-outline-dark"
          @click="() => $router.push({ name: 'ProductMaster' })"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ProductService from "@/services/api/product.service";
export default {
  name: "DetailProduct",
  data() {
    return {
      productCode: this.$route.query.id,
      objProduct: {},
      productCreateDate: null,
      productUpdateDate: null,
      isLoading: false,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.isLoading = true;
      try {
        await ProductService.getDetailProduct(this.productCode)
          .then((res) => {
            const data = res.data;
            this.objProduct = data.product;
            this.isLoading = false;
            this.productCreateDate = moment(data.product.productCreatedDate)
              .locale("th")
              .format("DD MMM YYYY");
            this.productUpdateDate = moment(data.product.productUpdatedDate)
              .locale("th")
              .format("DD MMM YYYY");
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Catch API: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    checkEmptyValue(val) {
      return val || "N/A";
    },
  },
};
</script>
